import { Component, Input, OnInit } from '@angular/core';
import { WCAGModel } from './wcag-model';

@Component({
  selector: 'app-reservation-wcag',
  templateUrl: './reservation-wcag.component.html',
  styleUrls: ['./reservation-wcag.component.css']
})
export class ReservationWcagComponent implements OnInit {
  @Input()
  public wcag: WCAGModel;

  constructor() { }

  ngOnInit(): void {
  }

  public toggleWCAG() {
    this.wcag.isWCAG = !this.wcag.isWCAG;
  }

  public addFontSize(val: number) {
    this.wcag.fontSize += val;
    if (this.wcag.fontSize > 20) {
      this.wcag.fontSize = 20;
    }
    else if (this.wcag.fontSize < 12) {
      this.wcag.fontSize = 12;
    }
  }

  public resetFontSize() {
    this.wcag.fontSize = 14;
  }

}
